import template from './review.html';
import controller from './review.controller';

let reviewComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default reviewComponent;



// WEBPACK FOOTER //
// ./client/pages/review/review.component.js